export enum TrendsType {
  avgSalesPerBay = 'AvgSalesPerBay',
  avgCarCount = 'AvgCarCount',
  avgTicket = 'AvgTicket'
}
